import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 15000
})

service.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => response.data,
  error => {
    let message = '网络请求失败'
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      message = '无法连接服务器，请确认 axdr-server 已启动（http://127.0.0.1:8088）且前端 dev 服务已重启'
    } else if (error.response?.data?.code) {
      return error.response.data
    } else if (error.response) {
      message = error.response.data?.message || `请求失败 (${error.response.status})`
    } else if (error.message) {
      message = error.message
    }
    console.warn('[API]', message, error.config?.url)
    // 返回标准错误结构，避免 Uncaught runtime errors 遮罩
    return { code: 500, message, data: null }
  }
)

export default service
